import { Model } from '@shared-features/models/model';
import { Expose } from 'class-transformer';
import { ShipmentCreationTemplateTypes } from "@shared/enums/shipment-creation-template-types.enum";

export class ShipmentCreationTemplate extends Model {
  @Expose()
  id: string;

  @Expose()
  type: ShipmentCreationTemplateTypes;

  @Expose()
  logo?: string;

  @Expose()
  object?: string;

  @Expose()
  objectType?: string;

  @Expose()
  isDefault: boolean;
}
